import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { WMTSSettings } from '../../explore-map.model';
import { ExploreMapService } from '../../explore-map.service';
import TileLayer from 'ol/layer/Tile';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-hvlsp-layer-panel',
  templateUrl: './hvlsp-layer-panel.component.html',
  styleUrls: ['./hvlsp-layer-panel.component.scss'],
})
export class HvlspLayerPanelComponent implements OnInit {
  @Input() map: any;
  onDestroy$ = new Subject();

  hvlspDatasets = [
    {
      displayName: ' All High-value large-scale pan European prototype themes',
      layerName: 'dataset-layer',
      visible: true,
      loaded: true,
      minZoom: 3,
      maxZoom: 21,
      zIndex: '-1',
    },
    {
      displayName: ' Administrative Unit',
      layerName: 'hvlsp_adminunit',
      visible: false,
      loaded: false,
      minZoom: 3,
      maxZoom: 21,
      zIndex: '-1',
    },
    {
      displayName: ' Transportation',
      layerName: 'hvlsp_transport',
      visible: false,
      loaded: false,
      minZoom: 11,
      maxZoom: 21,
      zIndex: '1',
    },
    {
      displayName: ' Hydrography',
      layerName: 'hvlsp_hydrography',
      visible: false,
      loaded: false,
      minZoom: 11,
      maxZoom: 21,
      zIndex: '1',
    },
  ];

  constructor(
    private exploreMapService: ExploreMapService,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.activatedRoute.paramMap.pipe(takeUntil(this.onDestroy$)).subscribe((params) => {
      if (params.get('mapServiceSlug') !== 'hvlsp') {
        this.setHvlspSublayersInvisible();
        this.setVisibility('dataset-layer', true);
      }
    });
  }

  layerInZoomRange(layer: any): boolean {
    if (this.map) {
      let view = this.map.getView();
      let currentZoom = view.getZoom();
      return !(Math.round(currentZoom) > layer.maxZoom || Math.round(currentZoom) < layer.minZoom) ;
    } else {
      return true;
    }
  }

  onCheckboxChange(hvlspLayer): void {
        if (hvlspLayer.layerName === 'dataset-layer' && !hvlspLayer.visible) {
      /// When checking hvlsp All, uncheck all others
      this.setHvlspSublayersInvisible();
    } else if (!hvlspLayer.visible) {
      // When checking an individual layer, uncheck hvlsp All
      this.hvlspDatasets.find((dataset) => dataset.layerName === 'dataset-layer').visible =
        false;
      this.setVisibility('dataset-layer', false);
    }
    hvlspLayer.visible = !hvlspLayer.visible;
    if (!hvlspLayer.loaded) {
      this.addHvlspLayer(hvlspLayer);
    } else {
      this.setVisibility(hvlspLayer.layerName, hvlspLayer.visible);
    }
    let visibleLayer = this.hvlspDatasets.map(layer => { return layer.visible? layer.layerName : null});
    visibleLayer = visibleLayer.map(layer => layer === "dataset-layer" ? "hvlsp_all" : layer)
    visibleLayer = visibleLayer.filter(x => x !== null);
    this.exploreMapService.changeWMSLayer(visibleLayer)
  }

  setHvlspSublayersInvisible(): void {
    this.hvlspDatasets.map((dataset) => {
      if (dataset.layerName !== 'dataset-layer' && dataset.loaded && dataset.visible) {
        dataset.visible = false;
        this.setVisibility(dataset.layerName, false);
      }
    });
  }

  setVisibility(layerName: string, flag: boolean): void {
    this.map.getLayers().forEach((layer) => {
      if (layer && layer.get('name') === layerName) {
        layer.setVisible(flag);
      }
    });
  }

  addHvlspLayer(layer: any): void {
    const newTileLayer = new TileLayer({
      source: null,
      properties: {
        name: layer.layerName,
      },
    });
    const wmtsSettings = new WMTSSettings();
    wmtsSettings.layerName = layer.layerName;
    wmtsSettings.url = `maps/wmts/${wmtsSettings.layerName}/{TileMatrixSet}/{TileMatrix}/{TileCol}/{TileRow}.png?token=${environment.elsToken}`;

    let wmtsSource = this.exploreMapService.getWMTSSource(wmtsSettings);

    layer.loaded = true;

    this.map.addLayer(newTileLayer);
    newTileLayer.setSource(wmtsSource);
    newTileLayer.setZIndex(layer.zIndex);
  }

  /**
   * @returns void
   */
  ngOnDestroy(): void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }
}
